import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Esto es solo para menopausia?',
  answer: 'Está diseñado para el patrón común en 40+ con sueño fragmentado, calor y mente acelerada. No diagnostica ni trata condiciones médicas, pero atiende los síntomas específicos de esta etapa.'
}, {
  question: '¿Y si una noche no me funciona?',
  answer: 'Una noche no define nada. Este sistema se evalúa por tendencia: minutos despierta y escalada emocional a lo largo de 7 noches. El objetivo es reducir la frecuencia y la intensidad, no la perfección inmediata.'
}, {
  question: '¿Tengo que comprar cosas?',
  answer: 'No. Puedes hacerlo con lo que tienes. El kit solo sugiere ajustes simples (capas, ventilación, luz, papel) que probablemente ya tienes en casa.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0F1923] py-24 px-6" data-id="element-1">
      <div className="max-w-2xl mx-auto" data-id="element-2">
        <h2 className="text-3xl font-bold text-[#F5E6D0] mb-12 text-center font-sans" data-id="element-3">
          Preguntas que probablemente te estás haciendo:
        </h2>

        <div className="space-y-4" data-id="element-4">
          {faqs.map((faq, i) => <div key={i} className="border border-[#B8A99A]/10 rounded-lg bg-[#15202B] overflow-hidden" data-id="element-5">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-6">
                <span className="text-[#F5E6D0] font-medium text-lg" data-id="element-7">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#E8614D] transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-8" />
              </button>

              <AnimatePresence data-id="element-9">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-10">
                    <div className="p-6 pt-0 text-[#B8A99A] font-serif leading-relaxed border-t border-[#B8A99A]/5" data-id="element-11">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}